import { Typography } from '@fox/atoms';
import MUITab from '@mui/material/Tab';
import MUITabs from '@mui/material/Tabs';
import { useState } from 'react';
import styled from 'styled-components';
import { FlexColumn } from '@fox/layout';
import { useComponentStyleContext } from '../../component-style-context';
import { SingleAccordion } from '../single-accordion';

type AccordionTab = {
	tabId: string;
	tabName: string;
	collapses: { title: string; mainContent: string }[];
};

interface ITabbedAccordionProbs {
	defaultExpanded?: boolean;
	headerBackgroundColour?: string;
	selectedTabBackgroundColour?: string;
	selectedTabFontColour?: string;
	tabs: AccordionTab[];
}

const TabStyleWrapper = styled.div<{ selectedTabBackgroundColour: string; selectedTabFontColour: string }>`
	.Mui-selected.MuiTab-root {
		${props => (props.selectedTabBackgroundColour ? `background: ${props.selectedTabBackgroundColour};` : '')}
		${props => (props.selectedTabFontColour ? `color: ${props.selectedTabFontColour};` : '')}
	}
	.MuiTabs-indicator {
		${props => (props.selectedTabFontColour ? `background: ${props.selectedTabFontColour};` : '')}
	}
`;

export function TabbedAccordions({
	tabs,
	defaultExpanded,
	headerBackgroundColour,
	selectedTabBackgroundColour,
	selectedTabFontColour
}: ITabbedAccordionProbs) {
	const { headerFont, headerFontColour, headerTextShadow } = useComponentStyleContext();
	const [selectedView, setSelectedView] = useState<string>(tabs?.[0]?.tabId);
	const handleChange = (_, newValue) => {
		setSelectedView(newValue);
	};
	return (
		<>
			<TabStyleWrapper selectedTabBackgroundColour={selectedTabBackgroundColour} selectedTabFontColour={selectedTabFontColour}>
				<MUITabs variant="standard" value={selectedView} onChange={handleChange}>
					{tabs.map(tab => {
						return (
							<MUITab
								sx={{
									...headerFont,
									...headerFontColour,
									...headerTextShadow,
									borderTopLeftRadius: '8px',
									borderTopRightRadius: '8px'
								}}
								key={tab.tabId}
								value={tab.tabId}
								label={<Typography>{tab.tabName}</Typography>}
							/>
						);
					})}
				</MUITabs>
			</TabStyleWrapper>
			{tabs.map(tab => {
				return (
					<FlexColumn
						role="tabpanel"
						hidden={selectedView !== tab.tabId}
						id={`mui-tabpanel-${tab.tabId}`}
						aria-labelledby={`mui-tab-${tab.tabId}`}
						key={`${tab.tabId}_${tab.tabName}`}
					>
						<SingleAccordion
							collapseModel={{ collapses: tab.collapses, expandByDefault: defaultExpanded }}
							headerBackgroundColour={headerBackgroundColour}
						/>
					</FlexColumn>
				);
			})}
		</>
	);
}
